module.exports = __webpack_public_path__ + "img/visa-color.365f383d.png";